import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

function StripeReadersModal({terminal, readers, connectedReader, stripeLoading, onClose, onConnect}) {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const showReaders = () => {
    return readers.map((reader, index) => {
      const isActive = connectedReader && (reader.id == connectedReader.id)
      
      return <button
        key={index}
        className={'btn btn-info stripe-reader' + (isActive ? '' : ' inactive')} 
        onClick={() => !isActive && !stripeLoading && connectToReader(reader)}
        disabled={loading}
      >
        { isActive && <span className='stripe-reader__icon'></span> }
        <span>{reader.label}</span>
        { isActive && <span className='stripe-reader__dot'></span> }
      </button>
    })
  }

  const connectToReader = async (reader) => {
    setLoading(true)
    if (connectedReader) terminal.disconnectReader()
    const connectResult = await terminal.connectReader(reader)
    setLoading(false)
    connectResult.error ? onConnectError(connectResult.error.message) : onConnect(reader)
  }

  const onConnectError = (error) => {
    if (connectedReader) onConnect(null)
    setError(error)
  }

  return (
    <ReactModal isOpen={true} onRequestClose={onClose}>
      <div className='stripe-reader-list'>
        { error && <label className='stripe-error'>{error}</label> }
        { loading && <div className='animated-spinner'></div>}
        { readers.length == 0 && <h4>No available readers</h4> }
        { !!readers.length && showReaders() }
      </div>
    </ReactModal>
  )
}

StripeReadersModal.propTypes = {
  terminal: PropTypes.object.isRequired,
  readers: PropTypes.array.isRequired,
  connectedReader: PropTypes.object,
  stripeLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConnect: PropTypes.func.isRequired
}

export default StripeReadersModal
